// Утилиты для работы с языками

export const getLanguageFromUrl = () => {
  const pathParts = window.location.pathname.split('/').filter(part => part !== '');
  if (pathParts[0] === 'en' || pathParts[0] === 'ru') {
    return pathParts[0];
  }
  return null;
};

export const setLanguageInUrl = (language) => {
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split('/').filter(part => part !== '');
  
  // Если первый элемент пути - это код языка
  if (pathParts[0] === 'en' || pathParts[0] === 'ru') {
    // Заменяем его на новый язык
    if (language === 'ru') {
      // Для русского языка убираем префикс
      const newPath = '/' + pathParts.slice(1).join('/');
      window.history.replaceState(null, '', newPath || '/');
    } else {
      // Для английского языка добавляем префикс
      const newPath = '/en/' + pathParts.slice(1).join('/');
      window.history.replaceState(null, '', newPath);
    }
  } else {
    // Если в URL нет префикса языка
    if (language === 'en') {
      // Для английского языка добавляем префикс
      const newPath = '/en' + (currentPath === '/' ? '/' : currentPath);
      window.history.replaceState(null, '', newPath);
    }
    // Для русского языка ничего не меняем
  }
};

export const updatePageLanguage = (language) => {
  // Обновляем атрибут lang у html тега
  document.documentElement.lang = language;
  
  // Обновляем localStorage
  localStorage.setItem('language', language);
  
  // Обновляем URL если необходимо
  setLanguageInUrl(language);
};